import _ from "lodash";

import MerchantClass from "./Merchant";
import MedicineClass from "./Medicine";
import PetClass from "./Pet";
import UserClass from "./User";
import TermClass from "./Term";
import SellerClass from "./Seller";
import ServiceClass from "./Service";
import AgendaAlertClass from "./AgendaAlert";
import { ChangelogController } from "./changelog-controller";
import { modelChangelog } from "../../models/global";

let CUser = null;
let CMerchant = null;
let CSeller = null;
let CService = null;
let CAgendaAlert = null;
let changelogController = null;

const CPet = {};
const CMedicines = {};
const CTerms = {};

export function MerchantController() {
  if (CMerchant) {
    return CMerchant;
  }
  CMerchant = new MerchantClass();

  return CMerchant;
}

export function UserController() {
  if (!CUser) CUser = new UserClass();

  return CUser;
}

export function PetController(petId) {
  const totalPets = _.size(CPet)
  if (!petId && !totalPets) {
    throw new Error(
      "Controllers/Global - PetController: ID não informado!"
    );
  }

  if (!petId && totalPets > 1) {
    throw new Error(
      "Controllers/Global - PetController: ID não informado!"
    );
  }

  if (!petId && totalPets === 1) {
    return _.values(CPet)[0];
  }

  if (!!CPet[petId]) {
    return CPet[petId];
  }

  CPet[petId] = new PetClass(petId);

  return CPet[petId];
}



export function MedicineController(id, props) {
  if (!id) {
    throw new Error(
      "Controllers/Global - MedicineController: ID não informado!"
    );
  }
  if (!!CMedicines[id]) {
    return CMedicines[id]
  }

  CMedicines[id] = new MedicineClass(id, props);

  return CMedicines[id]
}

export function TermController(id) {
  if (!id) {
    throw new Error(
      "Controllers/Global - TermController: ID não informado!"
    );
  }
  if (!!CTerms[id]) {
    return CTerms[id]
  }

  CTerms[id] = new TermClass(id);

  return CTerms[id]
}

export function SellerController(refreshSellers) {
  if (!CSeller) CSeller = new SellerClass(refreshSellers);

  return CSeller;
}

export function ServiceController(refreshService) {
  if (!CService) CService = new ServiceClass(refreshService);

  return CService;
}

export function controllerChangelog() {
  if (!changelogController) {
    changelogController = new ChangelogController({
      models: {
        changelog: modelChangelog(),
      }
    })
  }
  return changelogController;
}

export function AgendaAlertController() {
  if (!CAgendaAlert) CAgendaAlert = new AgendaAlertClass();

  return CAgendaAlert;
}
